import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-oppo-egypt-footer',
  templateUrl: './oppo-egypt-footer.component.html',
  styleUrls: ['./oppo-egypt-footer.component.scss']
})
export class OppoEgyptFooterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
